export default __webpack_public_path__ + "210d4d96205278eb96797e913aa2445a.svg";